export default __webpack_public_path__ + "static/media/grad-blue.a5ff3918.svg";